import { sendIt } from 'gatsby-plugin-purina-analytics/common/functions';
import React, { useContext } from 'react';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import BreedCard from 'src/templates/breed/listing/components/BreedCard';
import CardGenericSkeleton from '../card/CardGenericSkeleton';
import NoResults from './NoResults';
import { SearchListingContext } from './SearchListingContext';

interface Props {
  serverData?: DrupalSearch;
}

const BreedSearchResults: React.FC<Props> = function ({ serverData }) {
  const context = useContext(SearchListingContext);

  if (!context) {
    throw new Error(
      'Child components of SearchListing cannot be rendered outside the SearchListing component!',
    );
  }

  const { data, loaded } = context || {};
  const search_results = serverData?.search_results || data?.search_results;

  if (!loaded) {
    return (
      <Row className="pds-mb-5.5 pds-gx-2 pds-gy-3 md-bt:pds-gx-3 md-bt:pds-gy-4">
        {[...Array(12)].map((_, i) => {
          return (
            <Col key={`loading-card-${i}`} xs={6} md={4} className="d-flex">
              <CardGenericSkeleton />
            </Col>
          );
        })}
      </Row>
    );
  }

  if (!search_results) {
    return <NoResults />;
  }

  return (
    <Row id="search-results" className="pds-mb-5.5 pds-gx-2 pds-gy-3 md-bt:pds-gx-3 md-bt:pds-gy-4">
      {Object.values(search_results as BreedSearchResult[]).map(node => {
        return (
          <Col key={node.nid} xs={6} md={4} className="!pds-flex">
            <div>
              <BreedCard
                image={{
                  images: {
                    fallback: {
                      src: node.field_media_image ?? '',
                    },
                  },
                  layout: 'constrained',
                  width: 400,
                  height: 400,
                }}
                onClick={() => {
                  sendIt({
                    event: 'module_interaction',
                    eventParams: {
                      component_id: 'breeds',
                      component_type: 'breed_card',
                      content_name: node.title,
                    },
                  });
                }}
                link={node.url}
                title={node.title}
              />
            </div>
          </Col>
        );
      })}
    </Row>
  );
};

BreedSearchResults.displayName = 'SearchListing.BreedSearchResults';

export default BreedSearchResults;
